import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import MainLayout from "./MainLayout";
import Loader from "../components/ui/Loader";

const Home = lazy(() => import("./Home"));
const HowItWorks = lazy(() => import("./HowItWorks"));
const ErrorPage = lazy(() => import("./ErrorPage"));
const Dashboard = lazy(() => import("./Dashboard"));
const About = lazy(() => import("./About"));
const NutrientDetail = lazy(() =>
  import("../components/Nutrients/Info/NutrientDetail")
);
const NutrientsBrowse = lazy(() =>
  import("../components/Nutrients/Info/NutrientsBrowse")
);
const RecipesLayout = lazy(() => import("./RecipesLayout"));
const RecipeDetail = lazy(() => import("../components/Recipes/RecipeDetail"));
const Calculator = lazy(() => import("./Calculator"));
const ArticlesLayout = lazy(() => import("./ArticlesLayout"));
const ArticleDetail = lazy(() => import("../components/Content/ArticleDetail"));
const FAQs = lazy(() => import('../routes/FAQs'))

function RequireAuth({ token, redirectTo = "/auth", children }) {
  return token ? children : <Navigate to={redirectTo} replace />;
}

export default function AppRoutes({ token, username: _username }) {
  return (
    <Suspense fallback={<Loader fullPage />}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/articles" element={<ArticlesLayout />}>
            <Route
              index
              element={null}
            />
            <Route path=":slug" element={<ArticleDetail />} />
          </Route>
          <Route path="/faqs" element={<FAQs />} />
          <Route path="*" element={<ErrorPage />} />

          <Route
            path="/dashboard"
            element={
              <RequireAuth token={token} redirectTo="/">
                <Dashboard />
              </RequireAuth>
            }
          />

          {/* Recipe Routes */}
          <Route path="/recipes" element={<RecipesLayout mode="public" />}>
            <Route index element={null} />
            <Route path=":slug" element={<RecipeDetail />} />
          </Route>

          <Route
            path="/my-recipes"
            element={
              <RequireAuth
                token={token}
                redirectTo="/"
              >
                <RecipesLayout mode="private" />
              </RequireAuth>
            }
          >
            <Route index element={null} />
            <Route
              path=":slug"
              element={
                <RequireAuth token={token} redirectTo="/">
                  <RecipeDetail />
                </RequireAuth>
              }
            />
          </Route>

          {/* Nutritions information routes */}
          <Route path="/nutritions" element={<NutrientsBrowse />}>
            <Route
              index
              element={<div className="text-muted">Välj ett näringsämne</div>}
            />
            <Route path=":slug" element={<NutrientDetail />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
